module.exports = __webpack_public_path__ + "static/media/warningPrimary.fdb737d7.svg";